<template>
  <div>
    <RdsAlert
      v-if="!!alert"
      v-bind:title="alert.title"
      v-bind:text="alert.text"
      v-bind:showCancel="false"
      v-on:alertConfirm="onAlertConfirm"
    ></RdsAlert>
    <div class="slots">
      <div
        v-on:tap="selectedSlot=SLOTS.MATTINA"
        v-bind:class="{selected: selectedSlot===SLOTS.MATTINA}"
      >Mattina</div>
      <div
        v-on:tap="selectedSlot=SLOTS.POMERIGGIO"
        v-bind:class="{selected: selectedSlot===SLOTS.POMERIGGIO}"
      >Pomeriggio</div>
    </div>
    <div class="edit-card vertical-flex box-navetta">
      <div
        v-bind:class="{selected:autistaSelected.id===autista.id}"
        v-on:tap="setAutista(autista)"
        class="edit-card-item card-autista first-icon-container"
        v-for="autista in autisti"
        v-bind:key="autista.id"
      >
        <IconCar />
        <span class="label autista">{{autista.name}}</span>
      </div>
    </div>
    <div v-on:tap="save()" class="edit-card edit-card-button">
      <div>Conferma</div>
    </div>
  </div>
</template>
<script>
import RdsAlert from '../../components/RdsAlert';
import IconCar from '../../assets/images/icona_macchina_grey.svg?inline';
import config from '../../config';
import store from '../../stores';
import DriverShift from '../../models/driverShift.model';
export default {
  name: 'navetta-autista',
  components: {
    IconCar,
    RdsAlert
  },
  data() {
    return {
      autistaSelectedMattina: {},
      autistaSelectedPomeriggio: {},
      autisti: config.autisti,
      SLOTS: SLOTS,
      selectedSlot: SLOTS.POMERIGGIO,
      alert: null,
      cache: store.cache
    };
  },
  methods: {
    setAutista(autista) {
      if (this.selectedSlot === SLOTS.MATTINA) {
        this.autistaSelectedMattina = autista;
      } else {
        this.autistaSelectedPomeriggio = autista;
      }
    },
    onAlertConfirm() {
      this.alert = null;
    },
    save() {
      console.log('save');

      if (
        !this.autistaSelectedMattina.id ||
        !this.autistaSelectedPomeriggio.id
      ) {
        this.alert = {
          title: 'Error',
          text:
            'Seleziona il navettista sia per la mattina che per il pomeriggio'
        };
        return;
      }
      const date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const driverShift = new DriverShift({
        date: date.getTime(),
        shifts: {
          mattina: this.autistaSelectedMattina,
          pomeriggio: this.autistaSelectedPomeriggio
        }
      });
      store.add('driverShift', driverShift);
      this.alert = {
        title: 'Ok',
        text: 'Turni impostati correttamente.'
      };
    }
  },
  computed: {
    todayShift() {
      const date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);

      const shifts = this.cache.driverShifts
        .sort((a, b) => b.id - a.id)
        .find(d => d.date === date.getTime());
      console.log(shifts);
      if (!!shifts) {
        this.autistaSelectedMattina = shifts.shifts.mattina;
        this.autistaSelectedPomeriggio = shifts.shifts.pomeriggio;
      }
      return shifts;
    },
    autistaSelected() {
      if (this.todayShift) {
        console.log(this.todayShift);
      }
      if (this.selectedSlot === SLOTS.MATTINA) {
        return this.autistaSelectedMattina;
      } else {
        return this.autistaSelectedPomeriggio;
      }
    }
  }
};
const SLOTS = {
  MATTINA: 1,
  POMERIGGIO: 2
};
</script>
<style lang="scss" scoped>
.slots {
  border: #70707034 solid 1px;
  display: flex;
  background-color: #ffffff;
  & > div {
    $slot-padding: 22px 0 0;
    width: 50%;
    text-align: center;
    padding: $slot-padding;
    color: rgba(0, 0, 0, 0.6);
    &:after {
      content: '';
      border-bottom: #a31313 solid 2px;
      transform: scaleX(0);
      transition: transform 0.4s;
      display: block;
      margin: $slot-padding;
    }
    &.selected {
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      &:after {
        transform: scaleX(1);
      }
    }
  }
}

.edit-card {
  align-content: center;
  // padding: 0 0;
  // margin-top: 18px;
  img {
    width: 18px;
  }

  img,
  svg,
  i {
    margin: 0 20px 0 0;
    position: relative;

    &.rds-icon-car {
      color: $main-blue;
    }
  }

  .label {
    flex-grow: 1;
  }

  & > div {
    display: flex;

    &.edit-card-item {
      width: 90%;
      padding: 26px 0;
      align-items: center;
      display: flex;
      padding: 26px 20px;
      margin: 0;
      &.full-width {
        width: 100%;
        padding-bottom: 0;
      }
      &:nth-child(1) {
        border-radius: $default-border-radius;
      }
      &:nth-last-child(1) {
        border-radius: $default-border-radius;
      }
      .label {
        color: #000000;
      }
      img,
      i {
        position: relative;
        opacity: 0.5;
      }
    }
  }

  &.box-navetta {
    padding: 0;
  }
}

.time-slots {
  width: 100%;
  padding-bottom: 10px !important;
  background-color: #f7f7f7;

  .timeSlot {
    background-color: #e5e5e5;
    width: 100%;
    border: #f6f6f6 solid 1px;
    color: #7a7f85;
    height: 52px;
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    margin-left: 8px;
    &:nth-child(1) {
      margin-left: 0;
    }
    &.selected {
      background-color: $main-blue;
      color: #ffffff;
    }
    &.finished {
      background-color: #a31313;
      color: #ffffff;
    }
  }
}

.vertical-flex {
  // img {
  //   margin: 0 24px 30px;
  // }
  padding: 20px 0 30px;
  /*.first-icon-container {
        position: relative;
        &:after {
          position: absolute;
          content: '';
          background-image: url(/img/linea_tratteggiata_vericale.84d35209.svg);
          background-position: bottom;
          background-repeat: repeat-y;
          content: '';
          position: absolute;
          top: 0;
          left: 24px;
          height: 100px;
          width: 10px;
        }
      }*/
  .edit-card-item {
    background-color: #ffffff;
    position: relative;
    &::after {
      // background-image: linear-gradient(to right, #707070 50%, rgba(255, 255, 255, 0) 0%);
      // background-image: linear-gradient(90deg, #707070, #707070 75%, transparent 75%, transparent 100%);
      background-image: url('../../assets/images/linea_tratteggiata_orizzontale.svg');
      background-position: bottom;
      background-repeat: repeat-x;
      content: '';
      position: absolute;
      width: 90%;
      bottom: 0;
      //left: 2%;
      text-align: center;
      height: 10px;
    }
    &:nth-last-child(1) {
      &::after {
        content: none;
      }
    }
    .icon-navetta-location {
      opacity: 1;
      height: 21px;
    }
  }
}
.navetta-choose-loc {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 2;
}
.select-container {
  width: 100%;
  display: flex;
  align-items: center;
}
.edit-card-item .fake-select {
  width: 100%;
  .icon-arrow {
    opacity: 1;
    width: 8px;
    margin: 0;
    transition: all 0.3s;
  }
  .fake-select-label {
    padding: 0 22px 26px;
    display: flex;
    span {
      flex-grow: 1;
    }
  }
  .fake-select-option-container {
    // background-color: #e5e5e5;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 0 22px 0;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s;
  }
  &.open {
    .icon-arrow {
      transform: rotate(90deg);
    }
    .fake-select-option-container {
      max-height: 210px;
    }
  }

  .fake-select-option {
    padding: 26px 0;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-bottom: rgba(61, 61, 61, 0.3) solid 0.6px;
    }
    &:nth-last-child(1):after {
      content: none;
    }
  }
  .fake-select-label,
  .fake-select-option.selected {
    color: #1c3498;
  }
}

.autista {
  letter-spacing: 1px;
}

.box-autista {
  background-color: #ffffff;
}
.navetta-label {
  font-size: 0.9em;
  &.navetta-label-pomeriggio {
    margin-left: 9px;
  }
}

/*DONATO*/
.edit-card {
  padding: 0 0;
  margin-top: 18px;
  .slots {
    width: 100%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    color: #000000;
  }
}
.navetta-overlay-container {
  position: relative;
  .navetta-overlay {
    position: absolute;
    width: 100vw;
    height: 100%;
    left: -21px;
    top: 0;
    background-color: rgba(0, 0, 0, 0.72);
    z-index: 1;
  }
  .edit-cards-container {
    z-index: 2;
    position: relative;
  }
}
.slots.text-center {
  text-align: center;
  & > * {
    width: 100%;
    color: rgba(0, 0, 0, 1);
  }
}
.slots-time {
  width: 100%;
  // padding-top: 20px;
  // padding-bottom: 20px;
  margin: 0 0 20px;
  padding-top: 20px;
  // background-color: #f7f7f7;
  display: flex;
  .timeSlot {
    background-color: #e5e5e5;
    width: 100%;
    // border: #f6f6f6 solid 1px;
    color: #000000;
    padding: 13px 0;
    text-align: center;
    margin-left: 8px;
    border-radius: 5px;
    &:nth-child(1) {
      margin-left: 0;
    }
    &.selected {
      background-color: $main-blue;
      color: #ffffff;
    }
    &.finished {
      background-color: #a31313;
      color: #ffffff;
    }
  }
}

.edit-card div.edit-card-item.card-autista.selected {
  background-color: #607d8b;
  .label {
    color: #ffffff;
  }
}
</style>
